import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil, debounceTime } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';
import { MediaService } from '@core/services/media.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'sfx-ai-personalization',
    templateUrl: './ai-personalization.component.html',
    styleUrls: ['./ai-personalization.component.scss']
})
export class AIPersonalizationComponent implements OnInit, OnDestroy {

    // State management
    saving = false;

    companySummary = '';
    companyName = '';
    userSummary = '';
    userName = '';

    initialAISettings: any = {};

    private destroy$ = new Subject<void>();
    private save$ = new Subject<void>();

    // Methods
    constructor(
        @Inject('aiSettingsService') private aiSettings: any,
        @Inject('modelService') private modelService: any,
        public media: MediaService,
        public dialog: MatDialog,
        private translate: TranslateService
    ) {}

    public ngOnInit() {

        this.aiSettings.get().then((aiSettings: any) => {

            const settings = aiSettings?.data;

            this.companySummary = settings?.company?.summary ?? '';
            this.companyName = settings?.company?.name ?? this.modelService.me.team.name;
            this.userSummary = settings?.user?.summary ?? '';
            this.userName = settings?.user?.name ?? this.modelService.me.name;

        });

        this.save$
            .pipe(debounceTime(500), takeUntil(this.destroy$))
            .subscribe(() => {
                this.aiSettings.update({
                    company: { summary: this.companySummary, name: this.companyName },
                    user: { summary: this.userSummary, name: this.userName }
                });
            });
    }

    get EditorTooltip(): string {

        if (!this.modelService.me.is_admin) {
            return this.translate.instant('You do not have permission to edit these settings.');
        }

        return '';
    }

    get IsAdmin(): boolean {
        return this.modelService.me.is_admin;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        this.aiSettings.update({ company: { summary: this.companySummary, name: this.companyName }, user: { summary: this.userSummary, name: this.userName } });
    }

    public onNavigatingFrom() {
        if (!this.companySummary && !this.userSummary) {
            return;
        }

        this.aiSettings.update({ company: { summary: this.companySummary, name: this.companyName }, user: { summary: this.userSummary, name: this.userName } });
    }

    public onFieldChange() {
        this.save$.next();
    }
}
